import React from 'react';
import BreadcrumbsUI5 from "../../../../../gd-components/breadcrumbs/breadcrumbs-ui5";
import GDProjectName from "../../../../../gd-ui/project-name/project-name";
import {FieldViewProps} from "../../../../render/view";

type Options = {
    fullPath?       : boolean
    showIcon?       : boolean
    colorize?       : boolean
    maxParents?     : number
}

type Props = FieldViewProps & {
    options?    : Options,
    viewType?   : 'full-path' | 'property' | null
};


export default function FieldProject_GlistView(props:Props) {

    const value = props.field.getViewValue(props.model)

    if (!value) {
        return (
            <div className="ui5-txt-less-important-small txt-truncate">
                No parent
            </div>
        );
    }

    const showIcon          = true //_.get(props,'options.showIcon', false)
    // const colorize          = _.get(props,'options.colorize', false)

    return <GDProjectName className="ui5-txt-less-important-small"
                          projectId={value}
                          type="ui5-prop"
                          hintFullPath={true} />


    //
    //
    // switch (props.viewType) {
    //
    //     case 'full-path': {
    //
    //         const showIcon   = _.get(props, 'options.showIcon', false)
    //         const maxParents = _.get(props, 'options.maxParents', 3)
    //         const colorize   = _.get(props,'options.colorize', false)
    //
    //         // use ui5-prop gray m-r-10 in class to make it look like property
    //
    //         return <BreadcrumbsUI5 className={props.className} projectId={value} maxParents={maxParents}
    //                                showIcon={showIcon} colorize={colorize} disabled={true}/>
    //
    //     }
    //     case "property": {
    //         const showIcon          = _.get(props,'options.showIcon', false)
    //         // const colorize          = _.get(props,'options.colorize', false)
    //
    //         return <GDProjectName className={props.className}
    //                               projectId={value}
    //                               type={showIcon ? 'with-icon' : 'default'}
    //                               hintFullPath={true} />
    //     }
    //
    //     default:
    //         const projectName = gd.session.projects.get(value)?.name
    //         return <span className={props.className}>{projectName}</span>
    // }


}
